<template>
  <div style="height: 100%">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.4">
      <template #main>
        <TableMain name="one table" ref="GuestCQATable1" :fields="order_fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query" :table_height_adjust="-6"
          @tool_invoke="tool_invoke" @current_changed="current_changed">
          <template #query>
            询价申请编号：<el-input clearable size="small" style="width: 180px" v-model="ConsultQuoteNum"></el-input>
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain name="one table" ref="GuestCQATable2" :fields="fields" :title="table_title.title2"
          :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :isBusy="isBusy2"
          :hb_table_class="'hb_table_guest_vend_consult_handle_class2'" :table_height_adjust="12"
          @on_cell_button_click="on_cell_button_click">
          <template #operation>
            <el-button type="info" plain class="ml-2" @click="AppendIntoDetail"><i class="iconfont icon-down2"></i>
              &nbsp;&nbsp;{{ $t("common.selected") }}
            </el-button>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="GuestCQATable3" :fields="detail_fields" :show_query_container="false"
          :title="table_title.title3" :date_picker_label="date_picker_label" :table_height_adjust="0"
          :show_pagination="true" :show_filter="false" :show_toolbar="true" :show_toolbar_state="false" :pager_count="5"
          :isBusy="isBusy3" :show_toolbar_button="[0, 0, 0, 0, 1]" @state_change="detail_state_change"
          :hb_table_class="'hb_table_guest_vend_consult_handle_class3'"
          @on_cell_button_click="on_bottom_cell_button_click">
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="SaveDataTable3"
              :label="$t('common.save')" class="ml-2"></QueryButton>
            <QueryButton :type="'danger'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="CommitDataTable3"
              :label="$t('common.commit')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>
    <!-- 附件 -->
    <el-dialog title="附件列表" :visible.sync="accessoryVisible" width="60%" :top="'5vh'" :close-on-click-modal="false"
      @opened="dialogOpened">
      <FileUpload ref="refAccessory" :isGuest="true" :accessoryCategory="'ConsultQuote'" :showUpload="false"
        @setAccessory="setAccessory">
      </FileUpload>
    </el-dialog>
    <!-- 供应商附件管理 -->
    <el-dialog title="供应商附件列表" :visible.sync="accessoryVendVisible" width="60%" :top="'5vh'"
      :close-on-click-modal="false" @opened="bottomDialogOpened">
      <FileUpload ref="refVendAccessory" :isGuest="true" :accessoryCategory="'ConsultQuoteVend'"
        :showUpload="isBottomShowUpload" @setAccessory="bottomSetAccessory">
      </FileUpload>
    </el-dialog>
  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController"
import * as GuestController from "../../controllers/pages/GuestController"
import * as api from "../../shared/api"
import * as localStorageMgr from "../../shared/localStorageMgr"
import FileUpload from "../FileUpload.vue"
import QueryButton from "../components/base/QueryButton"
import SplitContainer3 from "../components/container/SplitContainer3"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    SplitContainer3,
    TableMain,
    QueryButton,
    FileUpload
  },
  data() {
    return {
      request_type: "?k=",
      guest_info: null,
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_consult_apply_order",
        title2: "table_consult_apply_order_detail",
        title3: "table_consult_detail"
      },
      order_fields: _.cloneDeep(GuestController.fields.order_fields),
      fields: _.cloneDeep(GuestController.fields.consult_handle_fields),
      detail_fields: _.cloneDeep(GuestController.fields.consult_handle_vend_fields),
      detail_cost_fields: _.cloneDeep(GuestController.fields.consult_handle_other_cost_fields),
      ConsultQuoteNum: "",//询价申请编号
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      BaseCurrency: [],
      BaseTaxGroup: [],
      BaseCostItems: [],
      ConsultQuoteOrderHis: [],
      current_accessory: null, ///当前派单选中附件
      current_vend_accessory: null,///当前供应商选中附件
      accessoryVisible: false,
      accessoryVendVisible: false,
      isBottomShowUpload: true
    }
  },
  async created() {
    this.guest_info = JSON.parse(this.ls.get(localStorageMgr.data.guest_info))
    await this.getBaseData()

    // let f = _.find(this.detail_fields, { key: "CurrencyCode" });
    // f["_options"] = {
    //   provider: (v) => {
    //     return _.map(_.uniqBy(this.BaseCurrency, "CurrencyCode"), (t) => {
    //       return {
    //         value: t.CurrencyCode,
    //         label: t.CurrencyCode + ":" + t.Txt,
    //       };
    //     });
    //   },
    // };
    let f = _.find(this.detail_fields, { key: "TaxGroup" })
    f["_options"] = {
      provider: (v) => {
        return _.map(_.uniqBy(this.BaseTaxGroup, "TaxGroup"), (t) => {
          return {
            value: t.TaxGroup,
            label: t.TaxGroup + ":" + t.TaxGroupName,
          }
        })
      },
    }
    f = _.find(this.detail_fields, { key: "InclTax" })
    f["_options"] = {
      provider: (v) => {
        return [{ value: "是", label: "是" }, { value: "否", label: "否" }]
      },
    }
  },
  methods: {
    async getBaseData() {
      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_base_data"),
        parameters: {},
        method: "get",
      })

      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        let rt = _result[0].result.data.Result
        this.BaseCurrency = rt[0]
        this.BaseTaxGroup = rt[1]
        this.BaseCostItems = rt[2]
      }
    },
    async on_query(set_data, date_range) {
      this.ConsultQuoteNum = _.trim(this.ConsultQuoteNum)
      this.isBusy = true
      set_data([])
      this.$refs.GuestCQATable2.SetData([])
      this.$refs.GuestCQATable3.SetData([])
      let _fromDate = "", _toDate = ""
      let _params = { ConsultQuoteNum: this.ConsultQuoteNum }
      if (!_.isNull(date_range) && this.ConsultQuoteNum == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(this.$date.addDays(new Date(_toDate), 1), "yyyy-MM-dd")
        _params["fromDate"] = _fromDate
        _params["toDate"] = _toDate
      }

      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_guest_consult_order"),
        parameters: _params,
        method: "get",
      })


      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        let dt = _result[0].result.data.Result[0]
        _.each(dt, (t) => {
          t.AccessoryCount = 0
          if (t.Accessory && t.Accessory != "")
            t.AccessoryCount = JSON.parse(t.Accessory).length
        })
        this.ConsultQuoteOrderHis = dt
        let main_dt = _.uniqBy(dt, "ConsultQuoteNum")
        set_data(_.orderBy(_.cloneDeep(main_dt), ["ConsultQuoteNum"], ["desc"]))
      }
      this.isBusy = false
    },

    ///打印导出
    tool_invoke(data, cb) {
      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    async current_changed(old, current) {
      this.$refs.GuestCQATable2.SetData([])
      this.$refs.GuestCQATable3.SetData([])
      if (current) {
        this.isBusy2 = true
        let dt = _.filter(this.ConsultQuoteOrderHis, { ConsultQuoteNum: current.ConsultQuoteNum })
        this.$refs.GuestCQATable2.SetData(_.cloneDeep(dt))
        this.isBusy2 = false
        this.isBusy3 = true
        await this.GetDataTable3(current.ConsultQuoteId)
        this.isBottomShowUpload = !current.is_approved && !current.isRefused
        this.isBusy3 = false
      }
    },
    async detail_state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        cb(false)
        return
      }

      let query_settings = [], m = { content_type: "", data: [] }
      let param = {
        url: api.pub_url("save", this.guest_info.idx, "pub_handle_guest_consult_vend_price"),
        parameters: {},
        method: "post",
      }
      let p = new FormData()
      m.content_type = "delete"
      if (data.state == "deleted") {
        m.data = _.map(_.filter(data.selected_items, (d) => { return d.id != "" }), (t) => { return { id: t.id } })
      }
      p.append("json", JSON.stringify(_.cloneDeep(m)))
      param.parameters = p
      query_settings.push(_.cloneDeep(param))
      let rt = await api.query_all_async(query_settings)
      if (rt) {
        if (data.state == "deleted")
          this.$refs.GuestCQATable3.RemoveItems(data.selected_items)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    AppendIntoDetail() {
      let select_items = this.$refs.GuestCQATable2.GetSelectedItems()
      if (select_items.length == 0) return
      _.each(select_items, (t) => {
        let m = {
          id: "",
          ItemId: t.ItemId,
          NameAlias: t.NameAlias,
          LineNum: t.LineNum,
          ConsultQuoteId: t.ConsultQuoteId,
          ConsultQuoteDetailId: t.ConsultQuoteDetailId,
          AccountNum: t.AccountNum,
          FromQty: t.FromQty,
          ToQty: t.ToQty,
          CurrencyCode: "CNY",
          InclTax: "是",
          TaxGroup: "VT13",
        }
        let is_exists = _.findIndex(this.$refs.GuestCQATable3.my_data, { LineNum: m.LineNum, ItemId: m.ItemId }) > -1
        if (!is_exists)
          this.$refs.GuestCQATable3.AppendItems(m)
      })
    },
    async GetDataTable3(ConsultQuoteId) {
      let query_settings = [], m = { content_type: "", data: [] }
      let param = {
        url: api.pub_url("save", this.guest_info.idx, "pub_handle_guest_consult_vend_price"),
        parameters: {},
        method: "post",
      }
      let p = new FormData()
      m.content_type = "get"
      m.data = [{ ConsultQuoteId: ConsultQuoteId }]
      p.append("json", JSON.stringify(_.cloneDeep(m)))
      param.parameters = p
      query_settings.push(_.cloneDeep(param))
      let rt = await api.query_all_async(query_settings)
      if (
        rt &&
        rt[0] &&
        rt[0].result &&
        rt[0].result.data &&
        rt[0].result.data.Result &&
        rt[0].result.data.Result[0]
      ) {
        let dt = rt[0].result.data.Result[0]
        _.each(dt, (t) => {
          t.AccessoryCount = 0
          if (t.Accessory && t.Accessory != "")
            t.AccessoryCount = JSON.parse(t.Accessory).length
          let m = _.find(this.ConsultQuoteOrderHis, { ConsultQuoteDetailId: t.ConsultQuoteDetailId })
          if (m) {
            t.ItemId = m.ItemId
            t.NameAlias = m.NameAlias
            t.LineNum = m.LineNum
          }
        })
        this.$refs.GuestCQATable3.SetData(dt)
      }
    },
    async SaveDataTable3(cb) {
      if (this.$refs.GuestCQATable3.my_data.length == 0) {
        cb(true)
        return
      }

      ///检查是否已确认
      let main_current = this.$refs.GuestCQATable1.GetCurrentItem()
      if (main_current && (main_current.is_approved || main_current.isRefused)) {
        this.msgToasts("抱歉，已确认或已关闭询价不能被变更！", "info")
        cb(true)
        return
      }

      //新增or修改
      let query_settings = []
      let data = _.cloneDeep(this.$refs.GuestCQATable3.my_data)
      //检查并处理数据
      let error_dt = []
      _.each(data, (t) => {
        if (t.ToQty && t.ToQty < t.FromQty)
          error_dt.push(t.ItemId)
      })
      if (error_dt.length > 0) {
        this.msgToasts(_.join(error_dt, ",") + "，结束数量不能小于起始数量！", "info")
        cb(true)
        return
      }
      let m = { content_type: "", data: [] }
      let param = {
        url: api.pub_url("save", this.guest_info.idx, "pub_handle_guest_consult_vend_price"),
        parameters: {},
        method: "post",
      }
      let add_dt = _.filter(data, (t) => {
        for (var k in t) {
          if (_.startsWith(k, "_")) delete t[k]
        }
        return t.id == ""
      })
      let update_dt = _.filter(data, (t) => {
        for (var k in t) {
          if (_.startsWith(k, "_")) delete t[k]
        }
        return t.id != ""
      })

      if (add_dt.length > 0) {
        let p = new FormData()
        m.content_type = "add"
        m.data = _.map(add_dt, (t) => { delete t.id; return t })
        p.append("json", JSON.stringify(_.cloneDeep(m)))
        param.parameters = p
        query_settings.push(_.cloneDeep(param))
      }
      if (update_dt.length > 0) {
        let p = new FormData()
        m.content_type = "update"
        m.data = update_dt
        p.append("json", JSON.stringify(_.cloneDeep(m)))
        param.parameters = p
        query_settings.push(_.cloneDeep(param))
      }
      let _result = await api.query_all_async(query_settings)
      if (_result && _result.length > 0) {
        await this.GetDataTable3(this.$refs.GuestCQATable1.GetCurrentItem().ConsultQuoteId)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
        cb(false)
      }
    },
    //提交
    async CommitDataTable3(cb) {
      let data = _.cloneDeep(this.$refs.GuestCQATable3.my_data)

      if (_.findIndex(data, (t) => t.id === 0 || t.id === "") > -1) {
        this.msgToasts("存在未保存数据，请先执行保存后再提交！", "info")
        cb(false)
        return
      }
      if (data.length === 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }

      ///检查是否已确认
      let main_current = this.$refs.GuestCQATable1.GetCurrentItem()
      if (main_current && (main_current.is_approved || main_current.isRefused)) {
        this.msgToasts("抱歉，已确认或已关闭询价不能被变更！", "info")
        cb(false)
        return
      }

      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        cb(false)
        return
      }

      let e_data = { title: `询价单：${main_current.ConsultQuoteNum}，供应商：${main_current.SEI_Name}，已完成报价`, data: {}, items: data }
      e_data.data = {
        ConsultQuoteNum: main_current.ConsultQuoteNum,
        Description: main_current.Description,
        create_by_username: main_current.create_by_username,
        create_at: main_current.send_email_date
      }

      let _result = await api.query_async({
        url: api.pub_url("get", this.guest_info.idx, "pub_get_notify_template"),
        parameters: { notify_type: "consult_order_vend_quote_complated" },
        method: "get",
      })

      if (
        _result &&
        _result[0] &&
        _result[0].result &&
        _result[0].result.data &&
        _result[0].result.data.Result &&
        _result[0].result.data.Result[0]
      ) {
        let dt = _result[0].result.data.Result[0]
        console.log(dt)
        let send_to = {}
        send_to[main_current.create_by_username] = ""
        let em = {
          category: dt[0].notify_type,
          idx: "",
          itemId: 0,
          notify_type: dt[0].notify_type,
          subject: `供应商：${main_current.SEI_Name},报价已完成`,
          content: "",
          SendTo: send_to
        }
        var fn = template.compile(dt[0].content)
        em.content = fn(e_data)
        console.log(em)
        let _rsult = await commonController.methods.sendOrCancelNotify("add", [em])
        if (!_.isNull(_rsult)) {
          await this.updateVendCommitState()
          this.msgToasts(this.$t("notify.email_send_success"), "success")
        }
      }
      cb(true)
    },
    async updateVendCommitState() {
      let main_current = this.$refs.GuestCQATable1.GetCurrentItem()
      let param = {
        url: api.pub_url("save", this.guest_info.idx, "pub_update_consult_vend_commited_state"),
        parameters: {},
        method: "post",
      }
      let query_settings = []
      let p = new FormData()
      p.append("id", main_current.consult_quote_vend_id)
      p.append("is_commited", 1)
      param.parameters = p
      query_settings.push(_.cloneDeep(param))

      let _result = await api.query_all_async(query_settings)
      if (_result && _result.length > 0)
        main_current.is_commited = 1

    },
    //#region 附件
    async on_cell_button_click(data) {
      this.current_accessory = data.item
      if (data.field.key == "Accessory") {
        this.accessoryVisible = true
      }
    },
    dialogOpened() {
      this.$refs.refAccessory.getAccessory(this.current_accessory.Accessory, this.current_accessory.ItemId)
    },

    setAccessory(data) {
      this.current_accessory.Accessory = data
    },
    //#endregion
    //#region 供应商附件
    async on_bottom_cell_button_click(data) {
      if (data.item.id == "") {
        this.msgToasts("请先保存报价，再执行附件相关操作！", "info")
        return
      }
      this.current_vend_accessory = data.item
      if (data.field.key == "Accessory") {
        this.accessoryVendVisible = true
      }
    },
    bottomDialogOpened() {
      this.$refs.refVendAccessory.getAccessory(this.current_vend_accessory.Accessory, this.current_vend_accessory.ItemId)
    },
    async bottomDialogClosed() {
      if (this.current_vend_accessory) {
        let param = {
          url: api.pub_url("save", this.guest_info.idx, "pub_handle_guest_consult_vend_price"),
          parameters: {},
          method: "post",
        }
        let m = { id: this.current_vend_accessory.id, Accessory: this.current_vend_accessory.Accessory }, ml = []
        if (m.id && m.id != "") ml.push(m)
        let query_settings = []
        if (ml.length > 0) {
          let t = { content_type: "", data: [] }
          let p = new FormData()
          t.content_type = "accessory"
          t.data = ml
          p.append("json", JSON.stringify(_.cloneDeep(t)))
          param.parameters = p
          query_settings.push(_.cloneDeep(param))
        }
        let _result = await api.query_all_async(query_settings)
        if (_result && _result.length > 0) {
          await this.GetDataTable3(this.$refs.GuestCQATable1.GetCurrentItem().ConsultQuoteId)
        }
      }
    },
    async bottomSetAccessory(data) {
      this.current_vend_accessory.Accessory = data
      await this.bottomDialogClosed()
    }
    //#endregion
  },
}
</script>
<style>
.hb_table_guest_vend_consult_handle_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}

.hb_table_guest_vend_consult_handle_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 108rem;
}
</style>
